"use client"

import { NpDiscountPill } from "src/components/np-design/components/NpDiscountPill"
import { NpRadioButtonReadOnly } from "src/components/np-design/components/NpRadioButtonReadOnly"
import { NpNotAvailableText } from "src/components/product-details/buyBox/NpNotAvailableText"
import { useCheapestPrice } from "src/components/product-details/buyBox/useCheapestPrice"
import { ResolvedProductData } from "src/components/product-details/useResolvedProductData"
import { NpSeriesCardButton } from "src/components/series/NpSeriesCardButton"
import { ShippingTime } from "src/components/styled/ShippingTime"
import { Img } from "src/components/unstyled/Img"
import { SeriesOptionValueData } from "src/data/series/types"
import { formatPriceShort } from "src/utilities/price"

export type NpProductColorCardValueProps = {
  value: SeriesOptionValueData
  product: ResolvedProductData
}

export type NpProductColorCardsProps = {
  options: NpProductColorCardValueProps[]
  value: string | undefined
  onChange: (value: string) => void
}

export const NpColorCards = ({ options, value, onChange }: NpProductColorCardsProps) => {
  const { pricesDiffer, cheapestPrice } = useCheapestPrice(options)

  return (
    <div className="flex w-full items-stretch gap-2">
      {options.map((option) => {
        const product = option.product
        const active = option.value.name === value
        const available = product.resolvedAvailable
        const fulfillmentFrom = product.resolvedFulfillmentFrom
        const discount = product.resolvedDiscount
        const coupon = product.resolvedCoupon
        const price = product.resolvedPrice
        const priceDifference = price - cheapestPrice

        return (
          <NpSeriesCardButton
            key={product.resolvedSku}
            onClick={() => onChange(option.value.name)}
            available={available}
            active={active}
            className="flex flex-col items-center gap-6 px-2 py-6"
          >
            <Img
              src={option.value.image}
              alt={option.value.name}
              className="aspect-square w-full max-w-14 rounded-lg"
            />

            <div className="flex flex-col items-center gap-2">
              <h3 className="font-product m-0 text-base text-pretty">{option.value.name}</h3>

              {discount && available && <NpDiscountPill>-{coupon?.text || formatPriceShort(discount)}</NpDiscountPill>}

              {!available ? (
                <NpNotAvailableText />
              ) : fulfillmentFrom ? (
                <div className="mx-auto w-30">
                  <ShippingTime fulfillmentFrom={fulfillmentFrom} />
                </div>
              ) : null}

              {pricesDiffer && (
                <div className="font-product flex flex-1 items-end justify-center text-lg">
                  +{formatPriceShort(priceDifference)}
                </div>
              )}
            </div>

            <div className="flex flex-1 items-end justify-center">
              <NpRadioButtonReadOnly active={active} disabled={!available} />
            </div>
          </NpSeriesCardButton>
        )
      })}
    </div>
  )
}
